/* eslint-env jquery */

(function ($) {
  $(document).ready(function () {

    validate.validators.register_file_types = function (value, options, key, attributes) {
      if (value === null || value.length === 0) {
        return
      }

      var allowedExtensions = ['png', 'jpg', 'jpeg', 'pdf']

      var ext = value.split('.')[1].toLowerCase()
      var inArray = allowedExtensions.indexOf(ext)

      if (inArray === -1) {
        return '^Only upload PDF, JPG, JPEG or PNG files'
      }
    }

    /*
    if ($('body.page-template-template-login').length === 0) {
      return
    }
    */

    var form = $('.form-register')
    var onlyLettersFormat = '[a-z_ -]+'
    var noNumbersFormat = '^([^0-9]*)$'
    var phoneFormat = '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$'

    $(form).submit(function (e) {
      e.preventDefault()
      submitForm()
    })

    var constraints = {
      'city[name_english]': {
        presence: {
          message: '^Name of local government can\'t be blank'
        },
        format: {
          pattern: onlyLettersFormat,
          flags: 'i',
          message: '^Name of local government in English may only contain English letters'
        }
      },
      'city[name_orig]': {
        presence: {
          message: '^Name of local government in official language can\'t be blank'
        },
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: '^Name of local government may not contain numbers'
        }
      },
      'city[country]': {
        presence: {
          message: '^Please select a country'
        },
        exclusion: {
          within: { dummy: 'Dummy' },
          message: '^Please select a country'
        }
      },
      'city[phone]': {
        format: {
          pattern: phoneFormat,
          flags: 'i',
          message: '^Please input a valid phone number'
        }
      },
      'city[website]': {
        url: {
          message: '^Please input a valid URL with http:// or https:// in front'
        }
      },
      'contact[first_name]': {
        presence: {
          message: '^Contact first name may not be empty'
        },
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: '^Contact first name may not contain numbers'
        }
      },
      'contact[last_name]': {
        presence: {
          message: '^Contact last name may not be empty'
        },
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: '^Contact last name may not contain numbers'
        }
      },
      'contact[title]': {
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: '^Contact title may not contain numbers'
        }
      },
      'contact[department]': {
        presence: {
          message: '^Contact department may not be empty'
        },
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: '^Contact department may not contain numbers'
        }
      },
      'contact[email]': {
        equality: {
          attribute: 'contact[email_confirm]',
          message: '^Please make sure both both email fields are matching'
        },
        presence: {
          message: '^Contact email may not be blank'
        },
        email: {
          message: '^Contact email is not a valid email'
        }
      },
      'contact[email_confirm]': {
        presence: {
          message: '^Contact email confirmation may not be blank'
        },
        email: {
          message: '^Contact email confirmation is not a valid email'
        }
      },
      'contact[phone]': {
        format: {
          pattern: phoneFormat,
          flags: 'i',
          message: '^Please input a valid phone number'
        }
      },
      'mayor[title]': {
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: '^Mayor title may not contain numbers'
        }
      },
      'mayor[first_name]': {
        presence: {
          message: '^Mayor first name can not be blank'
        },
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: '^Mayor first name may not contain numbers'
        }
      },
      'mayor[last_name]': {
        presence: {
          message: '^Mayor last name can not be blank'
        },
        format: {
          pattern: noNumbersFormat,
          flags: 'i',
          message: 'may not contain numbers'
        }
      },
      'mayor[email]': {
        presence: {
          message: '^Mayor email may not be blank'
        },
        email: {
          message: '^Mayor email is not a valid email'
        }
      },
      'user_agreement': {
        presence: {
          message: '^Please agree to our user agreement'
        },
        inclusion: {
          within: ['true']
        }
      },
      'mayor[approval]': {
        presence: true,
        inclusion: {
          within: ['true', 'false']
        }
      },
      'approval_file': {
        presence: function (value, attributes, attributeName, options, constraints) {
          if ($('#yes').prop('checked') === true) {
            if (value === null || value.length === 0) {
              return true
            }
          }
        },
        register_file_types: { options: 'no options' }
      },
      'data_privacy': {
        presence: {
          message: '^Please agree to our data privacy agreement'
        },
        inclusion: {
          within: ['true']
        }
      },
      'referer_other': {
        presence: function (value, attributes, attributeName, options, constraints) {
          if ($('#other').prop('checked') === true) {
            return {
              message: '^Referer can\'t be blank'
            }
          }

          return false
        }
      },
      'referer': {
        inclusion: {
          within: ['iclei_world_congress', 'iclei_regional_office', 'the_nature_conservancy', 'iucn', 'another_city', 'cwn_website', 'twitter', 'other'],
          message: '^Please choose where you\'ve heard about CitiesWithNature'
        }
      }
    }

    function submitForm () {
        var formData = validate.collectFormValues(form)
        var errors = validate(formData, constraints)

        //If the form is in the popup and errors on the first tab are found, return there.
        if (form.hasClass('form-register-popup') && errors) {            
            if ( 
                ('city[name_orig]' in errors) ||
                ('city[name_english]' in errors) ||
                ('city[country]' in errors) ||
                ('city[website]' in errors) ||                
                ('contact[first_name]' in errors) ||
                ('contact[last_name]' in errors) ||
                ('contact[department]' in errors) ||
                ('contact[email]' in errors) ||
                ('contact[email_confirm]' in errors)
                ) {
                    $('.js-reg-pop-inner-tab').removeClass('show');
                    $('.js-reg-pop-inner-tab[data-tab="1"]').addClass('show');
            }
        }

        showErrors(form, errors || {})
        if (!errors) {
            showSuccess()
        }
    }

    // Updates the inputs with the validation errors
    function showErrors (form, errors) {
      // We loop through all the inputs and show the errors for that input
      _.each(document.querySelectorAll('.form-register input[name], .form-register select[name]'), function (input) {
        // Since the errors can be null if no errors were found we need to handle
        // that
        showErrorsForInput(input, errors && errors[input.name])
      })
    }

    function showErrorsForInput (input, errors) {
      // This is the root of the input
      var formGroup = closestParent(input.parentNode, 'validator-row'), messages = formGroup.querySelector('.form-messages')
      // First we remove any old messages and resets the classes
      resetFormGroup(formGroup)
      // If we have errors
      if (errors) {
        // we first mark the group has having errors
        formGroup.classList.add('has-error')
        // then we append all the errors
        _.each(errors, function (error) { // eslint-disable-line
          addError(messages, error)
        })
      } else {
        // otherwise we simply mark it as success
        formGroup.classList.add('has-success')
      }
    }

    function closestParent (child, className) {
      if (!child || child === document) {
        return null
      }
      if (child.classList.contains(className)) {
        return child
      } else {
        return closestParent(child.parentNode, className)
      }
    }

    function resetFormGroup (formGroup) {
      // Remove the success and error classes
      formGroup.classList.remove('has-error')
      formGroup.classList.remove('has-success')
      // and remove any old messages
      _.each(formGroup.querySelectorAll('.help-block.error'), function (el) { // eslint-disable-line
        el.parentNode.removeChild(el)
      })
    }

    // Adds the specified error with the following markup
    // <p class="help-block error">[message]</p>
    function addError (messages, error) {
      var block = document.createElement('p')
      block.classList.add('help-block')
      block.classList.add('error')
      block.innerText = error
      messages.appendChild(block)
    }

    function showSuccess () {
      document.querySelector('.form-register').submit()
    }
  })
})(jQuery); // eslint-disable-line
